// extracted by mini-css-extract-plugin
export var icon = "_q5-0";